import React from "react";
import Logo from "assets/images/circularLCA_logo-new.svg";
import CombinedLogo from "assets/images/concular-combined-logo.svg";
import CircularAssetIcon from "assets/images/logo_circular_asset.png";
import OneLOGO from "assets/images/one_logo.svg";
import { useNavigate } from "react-router";
import clsx from "clsx";
import { IS_CONCULAR_ONE, IS_CIRCULAR_ASSET } from "utils";
import { IconLayoutSidebarLeftCollapse } from "@tabler/icons-react";
import { LicenseAppType } from "api-client";

const SidebarHeader = (props: {
  toggleSidebar: () => void;
  license?: LicenseAppType | null;
}) => {
  const navigate = useNavigate();

  let renderedLogo = Logo;

  if (IS_CONCULAR_ONE) {
    renderedLogo = OneLOGO;
  } else if (!props.license || props.license === LicenseAppType.Manufacturer) {
    renderedLogo = CombinedLogo;
  } else if (IS_CIRCULAR_ASSET || props.license === LicenseAppType.Asset) {
    renderedLogo = CircularAssetIcon;
  }

  return (
    <div className="flex flex-col">
      <div
        className={clsx(
          "flex flex-shrink-0 items-center px-4 pt-3 pb-4 justify-between",
          { "pb-3": IS_CONCULAR_ONE }
        )}
      >
        <img
          className={clsx("w-auto cursor-pointer h-6")}
          src={renderedLogo}
          alt="Concular"
          onClick={() => navigate("/")}
        />
        <IconLayoutSidebarLeftCollapse
          width={24}
          className="cursor-pointer hover:text-gray-500 rounded-full text-gray-700"
          onClick={props.toggleSidebar}
        />
      </div>
    </div>
  );
};

export default SidebarHeader;
